import { mappedColors } from '@pixee/design-system'

export type DefaultIndicatorProps = {
  size?: number
}

export const DefaultIndicator: React.FC<DefaultIndicatorProps> = ({ size = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 1.68848C17.6946 1.68868 22.3115 6.30528 22.3115 12C22.3113 17.6945 17.6945 22.3113 12 22.3115C6.30528 22.3115 1.68868 17.6946 1.68848 12C1.68853 6.30519 6.30519 1.68853 12 1.68848ZM12 2.6377C6.82986 2.63775 2.63775 6.82986 2.6377 12C2.6379 17.17 6.82995 21.3613 12 21.3613C17.1699 21.3611 21.3611 17.1699 21.3613 12C21.3613 6.82995 17.17 2.6379 12 2.6377Z"
        fill={mappedColors.neutral.neutral70}
      />
    </svg>
  )
}
